import { render, staticRenderFns } from "./LastMonthRevenue.vue?vue&type=template&id=2e0b751d&"
import script from "./LastMonthRevenue.vue?vue&type=script&lang=js&"
export * from "./LastMonthRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports